<mc-drawer
  [class]="'side-panel-wrapper modal-as-side-panel ' + extraCssClasses"
  height="100%"
  [nopadding]="nopadding"
  fit="small"
  backdropcloseactiondisabled="true"
  (closing)="onSecondaryButtonClick($event)"
>
  @if(storeService.showSidePanelNotification){
  <div class="modal-as-side-panel-notification-wrapper">
    <mc-notification
      class="mc-notification-top-full"
      [body]="storeService.sidePanelNotificationMessage"
      [appearance]="storeService.sidePanelNotificationType"
      [icon]="storeService.sidePanelNotificationIcon"
      width="100%"
    >
    </mc-notification>
  </div>
  }
  <ng-content></ng-content>
  <span class="side-panel-header" slot="heading">{{ title }}</span>
  @if(withFooter){
  <div slot="footer">
    <mc-button
      [disabled]="primaryButtonDisabled"
      class="side-panel-primary-action-button"
      appearance="primary"
      fit="medium"
      [attr.dialogaction]="closeOnPrimaryAction ? 'ok' : null"
      (click)="onPrimaryButtonClick($event)"
    >
      {{ primaryButtonLabel ?? "Save your changes" }}
    </mc-button>
    <Span class="button-group"></Span>
    <mc-button
      appearance="neutral"
      variant="filled"
      dialogaction="cancel"
      fit="medium"
      (click)="onSecondaryButtonClick($event)"
    >
      {{ secondaryButtonLabel ?? "Cancel" }}
    </mc-button>
  </div>
  }
</mc-drawer>
